module.exports = __webpack_public_path__ + "ac2aada6faaab9771900b95bf3eedf21.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/STAR.gif
// module id = 367
// module chunks = 0